import { Dispatch } from "redux";
import { toast } from "react-toastify";
import { setBudgetActuals, setBudgetActualsSearchFields } from "./reducer";


export const getBudgetActuals = (financialYear: string) => async (dispatch: Dispatch) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/budget-actual/${financialYear}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        dispatch(setBudgetActuals(data.data))
        return

    } catch (err: any) {
        toast.error(err.message ?? "Error getting budget actuals");
        return null
    }
}

export const syncBudgetActuals = async (financialYear: string): Promise<boolean> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/budget-actual/sync/${financialYear}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'POST',
        });

        if (!res.ok) {
            const errRes = await res.json();
            toast.error(errRes.message);
            return false
        }
        toast.success("Sync started. The page will refresh automatically when it finishes.")
        return true
    } catch (err: any) {
        toast.error(err.message ?? "Error starting the sync");
        return false
    }
}

export const getBudgetActualsSearchFields = () => async (dispatch: Dispatch) => {
        try {
        const url = `${process.env.REACT_APP_API_URL}/budget-actual/search-fields`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        dispatch(setBudgetActualsSearchFields(data.data))
        return

    } catch (err: any) {
        toast.error(err.message ?? "Error getting budget actuals search fields");
        return null
    }
}